import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Label extends Component {
    constructor(props) {
        super(props);
    }

    renderClasses() {
        return `label label--${this.props.color} ${this.props.classes}`;
    }

    render() {
        return <div className={this.renderClasses()}>{this.props.title}</div>;
    }
}
Label.propTypes = {
    color: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    classes: PropTypes.string,
};
